export default __webpack_public_path__ + "static/media/automated.7290d1d1.png";